export const FIRST = 'FIRST';
export const FIRST_IN_GROUP = 'FIRST_IN_GROUP';
export const LAST_IN_GROUP = 'LAST_IN_GROUP';
export const LAST = 'LAST';
export const LAST_COMMON_MESSAGE = 'LAST_COMMON_MESSAGE';
export const LAST_NON_FWD_MESSAGE = 'LAST_NON_FWD_MESSAGE';
export const LAST_READ_RECEIPT_MESSAGE = 'LAST_READ_RECEIPT_MESSAGE';

// Last message in the thread history where read receipt can be shown